import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Page,
  Font,
  Text,
  Image,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import logo from "./../../../img/logore.png";
import { useBarcode } from "react-use-barcode";

// Create styles
Font.register({
  family: "FamilyName",
  fontStyle: "normal",
  fontWeight: "bold",
});

const styles = StyleSheet.create({
  page: {
    width: "90%",
    height: "auto",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    width: "90%",
    height: "auto",
    marginTop: "30px",
    marginRight: "0",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
  },
  logo: {
    width: "80px",
    height: "30px",
  },
  barcode: {
    width: "80px",
    height: "40px",
  },
  title: {
    marginTop: "20px",
    marginBottom: "10px",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    fontStyle: "normal",
    fontSize: 14,
    fontWeight: 900,
  },
  title2: {
    marginTop: "0px",
    marginBottom: "10px",
    width: "90%",
    justifyContent: "flex-end",
    display: "flex",
    flexDirection: "row",
    textAlign: "end",
    fontStyle: "normal",
    fontSize: 10,
    fontWeight: 900,
  },
  headerCell: { fontWeight: "bold" },
  section: {
    margin: 10,
    padding: 10,
    width: "90%",
    height: "auto",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    border: "1px solid black",
  },
  groupsection: {
    width: "auto",
    height: "auto",
    display: "flex",
    flexDirection: "row",
  },
  goruplabels: {
    width: "auto",
    height: "auto",
    paddingRight: "0px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "baseline",
  },
  labels: {
    width: "auto",
    padding: "5px",

    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },

  goruplabels2: {
    width: "auto",
    height: "auto",
    paddingLeft: "0px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "baseline",
  },

  labels2: {
    width: "auto",
    padding: "5px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },

  groupfecha: {
    width: "25%",
    height: "auto",
    display: "flex",
  },
  fechalabels: {
    padding: "10x",
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  fecha: {
    padding: "10x",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
  },

  h3: {
    fontSize: 8,
    fontStyle: "bold",
    textAlign: "justify",
  },
  h5: {
    fontSize: 8,
    fontWeight: 400,
    textAlign: "justify",
    width: "160px",
    maxLines: "1",
  },
  table: {
    display: "table",
    width: "90%",
    height: "auto",
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },

  tableCodProced: {
    width: "10%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tableNombre: {
    width: "30%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tableFrec: {
    width: "10%",
    padding: "0px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tablePorcent: {
    width: "5%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tableMontoRec: {
    width: "15%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tableMontoARS: {
    width: "15%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },
  tableMontoAfil: {
    width: "15%",
    padding: "5px",
    backgroundColor: "#D0D4CA",
    border: "1px solid gray",
  },

  tableContentFrec: {
    width: "10%",
    padding: "5px",
    border: "1px solid gray",
  },

  tableContentCodProced: {
    width: "10%",
    padding: "5px",
    border: "1px solid gray",
  },

  tableContentNombre: {
    width: "30%",
    padding: "5px",
    display: "flex",
    textAlign: "left",
    border: "1px solid gray",
  },
  tableContentPorcent: {
    width: "5%",
    padding: "0px",
    display: "flex",
    textAlign: "center",
    border: "1px solid gray",
  },
  tableContentMontoRec: {
    width: "15%",
    padding: "5px",
    border: "1px solid gray",
  },
  tableContentMontoARS: {
    width: "15%",
    padding: "5px",
    border: "1px solid gray",
  },
  tableContentMontoAfil: {
    width: "15%",
    padding: "5px",
    border: "1px solid gray",
  },

  tableContentCellNombre: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "left",
    fontSize: 7,
  },
  tableContentCellFrec: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "left",
    fontSize: 7,
  },
  tableContentCellPorcent: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "center",
    fontSize: 7,
  },
  tableContentCellMontoRec: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "right",
    fontSize: 7,
  },
  tableContentCellMontoARS: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "right",
    fontSize: 7,
  },
  tableContentCellMontoAfil: {
    width: "100%",
    padding: "5px",
    display: "flex",
    textAlign: "right",
    fontSize: 7,
  },

  tableCellCodProced: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellNombre: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellCodFrec: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellPorcent: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellMontoRec: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellMontoARS: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },
  tableCellMontoAfil: {
    margin: "auto",
    padding: "2px",
    fontWeight: "bold",
    fontSize: 7,
  },

  tableCell: {
    margin: "auto",
    padding: "5px",
    fontWeight: 500,
    fontSize: 7,
  },

  tableCellFrec: {
    margin: "auto",
    padding: "5px",
    fontWeight: 500,
    fontSize: 7,
  },

  tablefooter: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    marginTop: "60px",
    marginBottom: "30px",
  },

  tablefooterFirma: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  tablefooterFirmaSpace: {
    color: "gray",
  },

  tablefooterFirmaLabel: {
    marginTop: "10px",
    fontSize: 10,
    fontWeight: "bold",
  },

  tablefooterFirmaAfil: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  tablefooterFirmaAfilLabel: {
    marginTop: "10px",
    fontSize: 10,
    fontWeight: "bold",
  },

  tablefooterInfo: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    marginTop: "60px",
    marginBottom: "30px",
  },

  tablefooterInfoFecha: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    marginBottom: "10px",
  },

  tablefooterInfoFechaLabel: {
    marginTop: "10px",
    fontSize: 9,
    fontWeight: "bold",
  },

  tablefooterInfotext: {
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  tablefooterInfoLabel: {
    marginTop: "10px",
    fontSize: 8,
    fontWeight: "bold",
  },

  footer: {
    width: "90%",
    height: "auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    marginTop: "40px",
    marginBottom: "20px",
  },

  footerSpace: {
    width: "90%",
    height: "20px",
    textAlign: "center",
    color: "gray",
    fontSize: 5,
  },
});

const ReprintPdfReport = () => {
  const { reprintdata } = useSelector((state) => state.reprint);

  const { cabecera } = reprintdata;
  const { detalle } = reprintdata;

  /* Variable que guarda la fecha de nacimiento del afiliado */
  const [fechaNac, setFechaNac] = useState(0);

  const barcode = useBarcode(cabecera[0]?.codigo, { width: "25px" });

  /* Variable que guarda la edad del afiliado */
  const [Edad, setEdad] = useState(0);

  const fecha = new Date();

  useEffect(() => {
    if (Array.isArray(cabecera)) {
      const [fechanac] = cabecera?.map((todo, index) => todo.fechanac);
      setFechaNac(fechanac);
    }

    function Edad() {
      var fechaNace = new Date(fechaNac);
      var fechaActual = new Date();

      var mes = fechaActual.getMonth();
      var dia = fechaActual.getDate();
      var año = fechaActual.getFullYear();

      fechaActual.setDate(dia);
      fechaActual.setMonth(mes);
      fechaActual.setFullYear(año);

      let edad = Math.floor(
        (fechaActual - fechaNace) / (1000 * 60 * 60 * 24) / 365
      );

      return edad;
    }

    setEdad(Edad);
  }, [fechaNac, cabecera]);

  return (
    <>
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document file={null}>
          <Page size="A4" style={styles.page} wrap>
            <View fixed style={styles.header}>
              <Image src={logo} style={styles.logo} />
              <Image src={barcode} style={styles.logo} />
            </View>

            <View fixed style={styles.title}>
              <Text>AUTORIZACIÓN DE SERVICIOS MÉDICOS DE SALUD</Text>
            </View>

            <View style={styles.section}>
              <View style={styles.groupsection}>
                <View style={styles.goruplabels}>
                  <View style={styles.labels}>
                    <Text style={styles.h3}>CÓDIGO AUT: </Text>
                  </View>
                  <View style={styles.labels}>
                    <Text style={styles.h3}>CENTRO PSS: </Text>
                  </View>
                  <View style={styles.labels}>
                    <Text style={styles.h3}>PÓLIZA: </Text>
                  </View>
                  <View style={styles.labels}>
                    <Text style={styles.h3}>NOMBRE AFILIADO: </Text>
                  </View>
                  <View style={styles.labels}>
                    <Text style={styles.h3}>ORIGEN: </Text>
                  </View>
                </View>

                {Array.isArray(cabecera)
                  ? cabecera.map((item, index) => {
                      return (
                        <View key={index} style={styles.goruplabels}>
                          <View style={styles.labels}>
                            <Text style={styles.h5}>{item.codigo}</Text>
                          </View>
                          <View style={styles.labels}>
                            <Text style={styles.h5}>
                              {item.codpss} {item.nombrE_PSS}
                            </Text>
                          </View>
                          <View style={styles.labels}>
                            <Text style={styles.h5}>{item.codafi}</Text>
                          </View>
                          <View style={styles.labels}>
                            <Text style={styles.h5}>
                              {item.comple} {item.apellidos}
                            </Text>
                          </View>

                          <View style={styles.labels}>
                            <Text style={styles.h5}>{item.origen}</Text>
                          </View>
                        </View>
                      );
                    })
                  : null}
              </View>

              <View style={styles.groupsection}>
                <View style={styles.goruplabels2}>
                  <View style={styles.labels2}>
                    <Text style={styles.h3}>SEXO: </Text>
                  </View>
                  <View style={styles.labels2}>
                    <Text style={styles.h3}>EDAD: </Text>
                  </View>
                  <View style={styles.labels2}>
                    <Text style={styles.h3}>DIAGNÓSTICO: </Text>
                  </View>
                  <View style={styles.labels2}>
                    <Text style={styles.h3}>TELÉFONO: </Text>
                  </View>
                  <View style={styles.labels2}>
                    <Text style={styles.h3}>FECHA AUT: </Text>
                  </View>
                </View>

                {Array.isArray(cabecera)
                  ? cabecera.map((item, index) => {
                      return (
                        <View key={index} style={styles.goruplabels2}>
                          <View style={styles.labels2}>
                            <Text style={styles.h5}>{item.sexo}</Text>
                          </View>
                          <View style={styles.labels2}>
                            <Text style={styles.h5}>{Edad}</Text>
                          </View>
                          <View style={styles.labels2}>
                            <Text style={styles.h5}>
                              {" "}
                              {item.coddia} {item.diagno}
                            </Text>
                          </View>
                          <View style={styles.labels2}>
                            <Text style={styles.h5}>{item.telefono}</Text>
                          </View>
                          <View style={styles.labels2}>
                            <Text style={styles.h5}>{item.fechA_AUT}</Text>
                          </View>
                        </View>
                      );
                    })
                  : null}
              </View>
            </View>

            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableCodProced}>
                  <Text style={styles.tableCellCodProced}>CÓDIGO</Text>
                </View>
                <View style={styles.tableNombre}>
                  <Text style={styles.tableCellNombre}>SERVICIOS</Text>
                </View>
                <View style={styles.tableFrec}>
                  <Text style={styles.tableCellFrec}>CANTIDAD</Text>
                </View>
                <View style={styles.tablePorcent}>
                  <Text style={styles.tableCellPorcent}>% </Text>
                </View>
                <View style={styles.tableMontoRec}>
                  <Text style={styles.tableCellMontoRec}>TOTAL SERVICIO</Text>
                </View>
                <View style={styles.tableMontoARS}>
                  <Text style={styles.tableCellMontoARS}>COBERTURA ARS</Text>
                </View>
                <View style={styles.tableMontoAfil}>
                  <Text style={styles.tableCellMontoAfil}>DIFERENCIA AFILIADO</Text>
                </View>
              </View>
              {Array.isArray(detalle)
                ? detalle.map((item, index) => {
                    return (
                      <View style={styles.tableRow} key={index}>
                        <View style={styles.tableContentCodProced}>
                          <Text style={styles.tableCell}>{item.codproc}</Text>
                        </View>
                        <View style={styles.tableContentNombre}>
                          <Text style={styles.tableContentCellNombre}>
                            {item.servicio}
                          </Text>
                        </View>
                        <View style={styles.tableContentFrec}>
                          <Text style={styles.tableContentCellFrec}>
                            {item.frecuencia}{" "}
                          </Text>
                        </View>
                        <View style={styles.tableContentPorcent}>
                          <Text style={styles.tableContentCellPorcent}>
                            {item.porcientO_COBERTURA}
                          </Text>
                        </View>
                        <View style={styles.tableContentMontoRec}>
                          <Text style={styles.tableContentCellMontoRec}>
                            {parseFloat(item.montototal).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </View>
                        <View style={styles.tableContentMontoARS}>
                          <Text style={styles.tableContentCellMontoARS}>
                            {parseFloat(item.montoars).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </View>
                        <View style={styles.tableContentMontoAfil}>
                          <Text style={styles.tableContentCellMontoAfil}>
                            {parseFloat(item.copago).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </View>
                      </View>
                    );
                  })
                : null}

              <View style={styles.tableRow}>
                <View style={styles.tableCodProced}>
                  <Text style={styles.tableCellCodProced}></Text>
                </View>
                <View style={styles.tableNombre}>
                  <Text style={styles.tableCellNombre}></Text>
                </View>
                <View style={styles.tableFrec}>
                  <Text style={styles.tableCellCodFrec}> </Text>
                </View>
                <View style={styles.tablePorcent}>
                  <Text style={styles.tableCellPorcent}></Text>
                </View>
                <View style={styles.tableMontoRec}>
                  <Text style={styles.tableCellMontoRec}>
                    TOTAL VALOR DEL SERVICIO
                  </Text>
                </View>
                <View style={styles.tableMontoARS}>
                  <Text style={styles.tableCellMontoARS}>TOTAL COBERTURA ARS</Text>
                </View>
                <View style={styles.tableMontoAfil}>
                  <Text style={styles.tableCellMontoAfil}>TOTAL DIFERENCIA AFILIADO</Text>
                </View>
              </View>

              <View style={styles.tableRow}>
                <View style={styles.tableContentCodProced}>
                  <Text style={styles.tableCellCodProced}></Text>
                </View>
                <View style={styles.tableContentNombre}>
                  <Text style={styles.tableCellNombre}></Text>
                </View>
                <View style={styles.tableContentFrec}>
                  <Text style={styles.tableContentCellFrec}></Text>
                </View>
                <View style={styles.tableContentPorcent}>
                  <Text style={styles.tableContentCellPorcent}></Text>
                </View>
                <View style={styles.tableContentMontoRec}>
                  <Text style={styles.tableContentCellMontoRec}>
                    ${" "}
                    {parseFloat(detalle[0].totalmontoreclamado).toLocaleString(
                      "en",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )}
                  </Text>
                </View>
                <View style={styles.tableContentMontoARS}>
                  <Text style={styles.tableContentCellMontoARS}>
                    ${" "}
                    {parseFloat(detalle[0].totalmontoars).toLocaleString("en", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
                <View style={styles.tableContentMontoAfil}>
                  <Text style={styles.tableContentCellMontoAfil}>
                    ${" "}
                    {parseFloat(detalle[0].totalcopago).toLocaleString("en", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
              </View>

              <View style={styles.tablefooter}>
                <View style={styles.tablefooterFirma}>
                  <Text style={styles.tablefooterFirmaSpace}>
                    _______________
                  </Text>
                  <Text style={styles.tablefooterFirmaLabel}>
                    Entregado Por
                  </Text>
                </View>
                <View style={styles.tablefooterFirmaAfil}>
                  <Text style={styles.tablefooterFirmaSpace}>
                    _______________
                  </Text>
                  <Text style={styles.tablefooterFirmaAfilLabel}>
                    Firma Afiliado
                  </Text>
                </View>
              </View>

              <View style={styles.tablefooterInfo}>
                <View style={styles.tablefooterInfoFecha}>
                  <Text style={styles.tablefooterInfoFechaLabel}>
                    <View style={styles.groupfecha}>
                      <View style={styles.fechalabels}>
                        <View style={styles.fecha}>
                          <Text style={styles.p}>FECHA RE-IMPRESIÓN: </Text>
                          <Text style={styles.p}>
                            {fecha.toLocaleString(["ban", "id"])}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </Text>
                </View>
                <View style={styles.tablefooterInfotext}>
                  <Text style={styles.tablefooterInfoLabel}>
                    Nuestra Política de Calidad: Somos una Administradora de
                    Riesgos de Salud, comprometida a proporcionar a nuestros
                    Prestadores de Servicios de Salud y a nuestros Afiliados, un
                    servicio oportuno y confiable bajo los más altos estándares
                    de calidad, dirigido a satisfacer sus necesidades y exceder
                    sus expectativas, aplicando un esquema de mejora continua
                    con base en la legislación vigente.
                  </Text>
                </View>
              </View>
            </View>
            <View fixed style={styles.footer}>
              <View style={styles.footerSpace}></View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </>
  );
};

export default ReprintPdfReport;
